import React, { useEffect, useState } from "react";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { toast } from "react-toastify";
import GridClients from "../../Components/Grid/GridClients";

const PageClientes: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [customers, setCustomers] = useState<any[]>([]);

  const handleCustomers = async () => {
    setLoading(true);
    try {
      const response = await api.get(BackEndRoutes.routes.CLIENTES.LIST);
      if (response.data) {
        setCustomers(response.data);
      }
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
      toast.error("Erro ao buscar clientes.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleCustomers();

  }, []);

  return (
    <div className="d-flex flex-column container-fluid">
      <GridClients
        clients={customers}
        reload={handleCustomers} />
    </div>
  );
};

export default PageClientes;